import { isArray } from 'util';
import * as I18n from 'circe/I18n';
import isFunction from 'lodash/isFunction';
import { morphShipmentToUI as _morphShipmentToUI } from 'domain/shipment/view/utils';
import { QUOTING_TYPES } from './constants';
import { SHIPMENT_STATUS } from '../shipment/constants';

export const morphShipmentToUI = _morphShipmentToUI;

export const isShipmentTrackable = (status, currentLocation) => currentLocation
  && [SHIPMENT_STATUS.IN_ROUTE, SHIPMENT_STATUS.LOADING, SHIPMENT_STATUS.UN_LOADING].includes(status);

export const isValidAddress = (val) => (isArray(val) && val[0].geometry
  ? undefined
  : I18n.str('invalidAddress', 'Please select an address'));

export const getLatLng = (location) => {
  try {
    if (location && location[0]) {
      const {
        geometry: { location: _location },
      } = location[0];
      if (_location) {
        return {
          lat: isFunction(_location.lat) ? _location.lat() : _location.lat,
          lng: isFunction(_location.lng) ? _location.lng() : _location.lng,
        };
      }
      return {};
    }
    return {};
  } catch (e) {
    return {};
  }
};

export const getShipmentDetails = (state, category, load) => {
  const { item: selectedLoadItemId, quantity } = load[0];
  const { childs: loadItems, name: equipmentName } = state.app.order.categories[category];
  const { name: truckSize } = loadItems.find((item) => item._id === selectedLoadItemId);

  return {
    equipment: equipmentName,
    truckSize,
    quantity,
  };
};

export function wizardSteps(quotingType = QUOTING_TYPES.FTL) {
  const quotingTypeStep = (quotingType) => ({
    title: '',
    breadcrumb: I18n.str('selectQuotingType', 'Quoting Type'),
    displayAsTitle: true,
    buttonsPlacement: 'none',
  });
  const equipmentStep = (quotingType) => ({
    title: I18n.str('selectEquipment', 'Which truck type do you need?'),
    breadcrumb: I18n.str('selectEquipment', 'Trailer Type'),
    displayAsTitle: true,
    buttonsPlacement: 'appendedToForm',
  });
  const orderDetailsStep = (quotingType) => ({
    title: I18n.str('orderDetails', 'Order Details'),
    breadcrumb: I18n.str('orderDetails', 'Order Details'),
    displayAsTitle: false,
    buttonsPlacement: 'appendedToForm',
  });
  const pickUpDeliveryStep = (quotingType) => ({
    title: I18n.str('pickupDelivery', 'Pickup & Delivery'),
    breadcrumb: I18n.str('pickupDelivery', 'Pickup & Delivery'),
    displayAsTitle: false,
    buttonsPlacement: 'newLine',
  });

  if (QUOTING_TYPES.FTL === quotingType) {
    return [
      quotingTypeStep(quotingType),
      equipmentStep(quotingType),
      orderDetailsStep(quotingType),
      pickUpDeliveryStep(quotingType),
    ];
  }
  return [quotingTypeStep(quotingType), pickUpDeliveryStep(quotingType)];
}
